import React from 'react';

import './styles.scss';

import Select from "@material-ui/core/Select";
import Caret from "../../../Display/Caret";
import selectCtor from "../../utils/selectCtor";
import FormControl from "@material-ui/core/FormControl";

import LabelDisplay from "../LabelDisplay";
import HelperText from "../HelperText";

const SelectWrapper = ({children, id, className, hasError, disabled}) => (
  <div
    id={id}
    className={
      (className ? className : '')
      + (disabled ? ' disabled' : '')
      + (hasError ? ' error' : '')
    }
  >
    {children}
  </div>
);

const SelectDisplay = ({id, value, name, itemsDisplay, dropdownClassName, onChange, disabled}) => {
  return (
    <Select
      id={`${id}Input`}
      value={value || ''}
      onChange={(e) => onChange(name, e.target.value)}
      IconComponent={Caret}
      disabled={disabled}
      MenuProps={{
        classes: { paper: 'merchant-select-items' }
      }}
    >
      {itemsDisplay}
    </Select>
  );
}

export default selectCtor(({
 className,
 labelProps,
 selectProps,
 helperTextProps,
}) => (
  <SelectWrapper
    id={selectProps.id}
    className={['merchant-field', 'merchant-select', className].join(' ')}
    hasError={helperTextProps.showError}
    disabled={selectProps.disabled}
  >
    <FormControl variant="outlined">
      <LabelDisplay {...labelProps} />
      <SelectDisplay {...selectProps} />
    </FormControl>
    <HelperText {...helperTextProps} />
  </SelectWrapper>
));
